module.exports = __webpack_public_path__ + "img/arca-continental.65b30bf1.png";